import {Component, Input, OnInit, SimpleChanges} from "@angular/core";
import {BoardService} from "../../../service/board/board.service";
import {Comment, CommentPost} from "../../../service/board/board";
import {AuthService} from "../../../service/auth/auth.service";
import {CommonService} from "../../../service/common/common.service";
import {GtmService} from "../../../service/gtm/gtm.service";
import {ImageUploadService} from "../../../service/image/image.service";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'],
  providers: [BoardService, DatePipe, ImageUploadService]
})
export class CommentComponent implements OnInit {

  @Input() id: number;
  @Input() list: string;
  @Input() board: any;

  comments: Comment[];
  allComment: number;

  constructor(private boardService: BoardService,
              private commonService: CommonService,
              private authService: AuthService,
              private gtmService: GtmService,
              private imageService: ImageUploadService,
              private datePipe: DatePipe) {
  }

  ngOnInit() {
    this.allComment = 0;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['id']) {
      let id = changes['id'].currentValue;

      this.boardService.getByComment(id).subscribe(
        comments => {
          this.comments = comments.content
          this.allComment = 0;

          this.comments.map(o => {
            this.allComment += 1 + o.comment.length;
          })
        }
      );
    }
  }

  onCanDelete(index: number): boolean {
    return this.comments[index].member.email == this.authService.getEmail() || this.authService.isAdmin();
  }
  onCanDeleteReply(commet): boolean {
    return commet.member.email == this.authService.getEmail() || this.authService.isAdmin();
  }

  onDeleteComment(index: number) {
    if (window.confirm('댓글을 삭제 하시겠습니까?')) {
      this.boardService.deleteByComment(this.comments[index].id).subscribe(
        comment => {
          let findIndex = this.comments.findIndex(item => item.id === comment.id);
          if (findIndex != -1) this.comments.splice(findIndex, 1);
          this.board.countOfComments--;
          this.allComment--;
        }
      );
    }
  }
  onDeleteReplyComment(comment, replyCommet, index){
    if (window.confirm('댓글을 삭제 하시겠습니까?')) {
      this.boardService.deleteByComment(replyCommet.id).subscribe(
        resComment => {
          comment.comment.splice(index, 1);
          this.board.countOfComments--;
          this.allComment--;
        }
      );
    }
  }

  showProfile(email: string) {
    this.commonService.addProfileEvent(email);
  }

  isMine(email: string): boolean {
    return this.authService.getEmail() == email;
  }

  myPhoto(): string {
    return this.authService.me.photo || 'assets/images/member-default.png';
  }

  onLike(comment) {
    if (comment.likeByMe) {
      this.boardService.commentunlike(comment.id).subscribe(
        result => {
          comment.likeByMe = false;
          comment.countOfLikes--;
        }
      );
    } else {
      this.boardService.commentlike(comment.id).subscribe(
        result => {
          comment.likeByMe = true;
          comment.countOfLikes++;
        }
      );
    }
  }

  toggleReplyComment(comment) {
    if(comment.showReplyComment) {
      if(comment.isSetReplyText) {
        if(window.confirm("입력중인 댓글을 삭제하고 취소하겠습니까?")){
          comment.isSetReplyText = false;
          comment.showReplyComment = false;
          return;
        } else {
          return;
        }
      }
      comment.isSetReplyText = false;
      comment.showReplyComment = false;
    } else {
      if(!comment.comment) comment.comment = []
      comment.showReplyComment = true;
    }
  }

  onRecvComment(comment) {
    this.comments.push(comment);
    this.board.countOfComments++;
    this.allComment++;
  }

  onSetReplyText(setVal, comment) {
    // console.log(setVal)
    comment.isSetReplyText = setVal;
  }

  onRecvReplyComment(replyComment, comment) {
    comment.showReplyComment = false;
    comment.isSetReplyText = false;
    if(comment.comment === undefined) comment.comment = [];
    comment.comment.push(replyComment);
    this.board.countOfComments++;
    this.allComment++;
  }
}



// WEBPACK FOOTER //
// ./src/app/member/shared/comment/comment.component.ts